/* Tropical Harvest shared gift editing, labels and cart checkout protection. */
(function () {
  'use strict';
  if (window.THGiftCart && window.THGiftCart.version === 7 && typeof window.THGiftCart.createDraft === 'function') return;
  const CARD = 47692607750315, WRAP = 47692607783083, EXTRA = 47701244346539;
  const CHRISTMAS = 48364284313771, PAPER = 48364284674219;
  const ids = [CARD, WRAP, EXTRA, CHRISTMAS, PAPER];
  const isChristmas = service => service === 'christmas' || service === 'christmas-paper';
  function validateService(draft) {
    const name = String(draft.recipient || '').trim(), message = String(draft.message || '').trim();
    if (!name || name.length > 80 || !['card','wrap','christmas','christmas-paper'].includes(draft.service) ||
      (isChristmas(draft.service) ? message.length > 35 : (!message || message.length > 250)))
      throw new Error('Check the recipient and gift option. Christmas tag messages are optional, up to 35 characters; regular card messages are required, up to 250 characters.');
  }
  function serviceLines(draft, packets) {
    if (isChristmas(draft.service)) return [{id:CHRISTMAS,quantity:packets,kind:false}].concat(draft.service === 'christmas-paper' ? [{id:PAPER,quantity:1,kind:'paper'}] : []);
    return [{id:draft.service === 'wrap' ? WRAP : CARD,quantity:1,kind:false}].concat(draft.service === 'wrap' && packets > 1 ? [{id:EXTRA,quantity:packets-1,kind:true}] : []);
  }
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  const pendingKey = 'th-gift-edit-pending:' + root;
  const leaseKey = 'th-gift-write-lock:' + root;
  const clone = value => JSON.parse(JSON.stringify(value));
  const props = item => item.properties || {};
  const reference = item => String(props(item)['_Gift reference'] || '');
  const variant = item => Number(item.variant_id || item.id);
  const plan = item => Number(item.selling_plan || item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || 0);
  const isCarrier = item => props(item)._byo_carrier === 'true' || variant(item) === 45956039901355;
  const isBlend = item => Boolean(props(item)._BYO_STATE && props(item)._byo_group) && !isCarrier(item);
  const carrierFor = (cart, item) => cart.items.filter(line => isCarrier(line) && props(line)._byo_group === props(item)._byo_group);
  const isService = item => ids.includes(variant(item));
  const isGift = item => Boolean(reference(item)) || String(props(item)._Gift || '').toLowerCase() === 'yes' || isService(item);
  const stable = value => JSON.stringify(Object.keys(value).sort().map(key => [key, value[key]]));
  function signature(item, ignoreQuantityProperty) {
    const p = Object.assign({}, props(item));
    if (ignoreQuantityProperty) delete p['_Gift quantity'];
    return JSON.stringify([variant(item), plan(item), stable(p)]);
  }
  function fingerprint(cart) {
    return JSON.stringify(cart.items.filter(isGift).map(item => [signature(item), Number(item.quantity),
      Number(item.original_price ?? item.price ?? 0), Number(item.final_line_price ?? item.line_price ?? 0)]).sort((a,b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
  }
  function amounts(cart, all) {
    const map = {};
    cart.items.filter(item => all || isGift(item)).forEach(item => { const key = signature(item); map[key] = (map[key] || 0) + Number(item.quantity); });
    return map;
  }
  function equal(a, b) { return stable(a) === stable(b); }
  function changeAmount(map, sig, delta) {
    map[sig] = (map[sig] || 0) + delta;
    if (!map[sig]) delete map[sig];
    if (map[sig] < 0) throw new Error('Gift quantities changed. Please review your cart.');
  }
  function inspect(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Could not check your cart. Please try again.');
    const lines = cart.items.filter(isGift);
    if (!lines.length) return null;
    const refs = new Set(lines.map(reference));
    const main = lines.filter(item => [CARD, WRAP, CHRISTMAS].includes(variant(item)));
    const fruit = lines.filter(item => !isService(item) && !isCarrier(item));
    fruit.filter(isBlend).forEach(item => {
      const carriers = carrierFor(cart,item);
      if (Number(item.quantity) !== 1 || carriers.length !== 1 || reference(carriers[0]) !== reference(item) ||
        !Number.isSafeInteger(Number(props(item)._byo_price_cents)) || Number(props(item)._byo_price_cents) < 1 ||
        Number(carriers[0].quantity) !== Number(props(item)._byo_price_cents) || Number(carriers[0].original_price ?? carriers[0].price) !== 1)
        throw new Error('A personalised blend and its price need checking together in your cart.');
    });
    lines.filter(isCarrier).forEach(line => {
      if (fruit.filter(item => isBlend(item) && props(item)._byo_group === props(line)._byo_group).length !== 1)
        throw new Error('A blend price is missing its personalised blend. Please review the cart.');
    });
    const packets = fruit.reduce((sum,item) => sum + Number(item.quantity), 0);
    const extras = lines.filter(item => variant(item) === EXTRA);
    const extraUnits = extras.reduce((sum,item) => sum + Number(item.quantity), 0);
    const paper = lines.filter(item => variant(item) === PAPER);
    const paperUnits = paper.reduce((sum,item) => sum + Number(item.quantity), 0);
    const christmas = main.length === 1 && variant(main[0]) === CHRISTMAS;
    if (refs.has('') || refs.size !== 1 || main.length !== 1 || Number(main[0].quantity) !== (christmas ? packets : 1) || packets < 1 ||
      extraUnits !== (variant(main[0]) === WRAP ? packets - 1 : 0) || paperUnits > 1 || (!christmas && paperUnits !== 0)) {
      throw new Error('Your gift needs checking. Please review its products and gifting charges in your cart before continuing.');
    }
    const p = props(main[0]);
    const recipient = String(p.Recipient || p._Recipient || p['_Gift for'] || p['Gift for'] || '').trim();
    const messageKeys=christmas ? ['Christmas tag message','Card message','Personalised card','Gift message','_Gift message'] : ['Card message','Personalised card','Gift message','_Gift message','Christmas tag message'];
    const message = String(messageKeys.map(key=>p[key]).find(value=>value!=null && String(value).trim()!=='') || '').trim();
    const recipientKeys = ['Recipient','_Recipient','_Gift for','Gift for','_For gift','Part of gift for'];
    if (!recipient || (christmas ? message.length > 35 : (!message || message.length > 250)) || lines.some(line => {
      const values = recipientKeys.filter(key => props(line)[key] != null && String(props(line)[key]).trim() !== '')
        .map(key => String(props(line)[key]).trim());
      return !values.length || values.some(value => value !== recipient);
    })) throw new Error('The gift recipient or card message needs checking. All gift products and charges must belong to the same recipient. Please edit the gift in the cart.');
    if (lines.some(line => !Number.isInteger(Number(line.quantity)) || Number(line.quantity) < 1))
      throw new Error('Your gift quantities need checking in the cart.');
    return {reference:reference(main[0]), main:main[0], fruit, extras, paper, lines, packets,
      recipient:p.Recipient || p._Recipient || p['_Gift for'] || p['Gift for'] || '',
      message:message, service:christmas ? (paperUnits ? 'christmas-paper' : 'christmas') : variant(main[0]) === WRAP ? 'wrap' : 'card'};
  }
  async function request(path, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      return await fetch(root + path, Object.assign({credentials:'same-origin', cache:'no-store'}, options, {signal:controller.signal}));
    } finally { clearTimeout(timer); }
  }
  async function readCart() {
    const response = await request('cart.js', {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Could not check your cart. Please try again.');
    const cart = await response.json();
    if (!cart || !Array.isArray(cart.items)) throw new Error('Could not check your cart. Please try again.');
    return cart;
  }
  function pending() {
    let raw;
    try { raw = localStorage.getItem(pendingKey); }
    catch (_) { throw new Error('Please enable browser storage before changing a gift. Regular purchases remain available.'); }
    if (!raw) return null;
    try {
      const value = JSON.parse(raw);
      if (value.version !== 3 || !value.reference || !Array.isArray(value.ops) || !value.expected || !value.final) throw new Error();
      return value;
    } catch (_) { throw new Error('A previous gift save needs checking. Please review your cart before making another gift change.'); }
  }
  function remember(record) {
    try {
      localStorage.setItem(pendingKey, JSON.stringify(record));
      if (!localStorage.getItem(pendingKey)) throw new Error();
    } catch (_) { throw new Error('Could not protect this gift save. No further changes were made. Please enable browser storage and try again.'); }
  }
  function forget() { localStorage.removeItem(pendingKey); }
  function legacyPending(cart) {
    let old;
    try { old = JSON.parse(sessionStorage.getItem('th-gift-pending:' + root) || 'null'); } catch (_) { return true; }
    if (!old) return false;
    if (old.observed && !cart.items.some(item => reference(item) === old.reference) && !cart.items.some(isGift)) {
      sessionStorage.removeItem('th-gift-pending:' + root); return false;
    }
    return true;
  }
  async function pendingState(cart) {
    const record = pending();
    if (!record) return legacyPending(cart) ? {legacy:true} : null;
    const current = amounts(cart, record.standard);
    if (record.mode !== 'external' && (record.complete || record.index === record.ops.length)) {
      if (equal(current, record.final)) {
        if (Object.keys(current).length) { inspect(cart); verifyServicePrices(cart); }
        forget(); return null;
      }
    }
    // A gift confirmed after a write can be deliberately removed using the existing cart action.
    // An uncertain never-observed add must not be retried just because one read was empty.
    if (!record.standard && record.observed && !cart.items.some(isGift)) { forget(); return null; }
    return record;
  }
  let busy = false;
  async function withLock(fn) {
    if (busy) throw new Error('A gift request is already running. Please wait.');
    busy = true;
    announceOperation();
    try {
      if (typeof navigator !== 'undefined' && navigator.locks) {
        return await navigator.locks.request('th-personalised-gift:' + root, {ifAvailable:true}, async lock => {
          if (!lock) throw new Error('A gift is being changed in another tab. Please wait and try again.');
          return fn();
        });
      }
      // Older browsers: a best-effort lease, not an atomic cross-tab guarantee.
      const owner = Date.now() + '-' + Math.random();
      let timer;
      try {
        const previous = JSON.parse(localStorage.getItem(leaseKey) || 'null');
        if (previous && previous.until > Date.now()) throw new Error('A gift is being changed in another tab. Please wait and try again.');
        localStorage.setItem(leaseKey, JSON.stringify({owner, until:Date.now()+45000}));
        if (JSON.parse(localStorage.getItem(leaseKey)).owner !== owner) throw new Error('Another gift request is running. Please try again.');
        timer = setInterval(() => {
          try { const value = JSON.parse(localStorage.getItem(leaseKey) || 'null'); if (value && value.owner === owner) localStorage.setItem(leaseKey, JSON.stringify({owner,until:Date.now()+45000})); } catch (_) {}
        }, 10000);
        return await fn();
      } finally {
        if (timer) clearInterval(timer);
        const value = JSON.parse(localStorage.getItem(leaseKey) || 'null');
        if (value && value.owner === owner) localStorage.removeItem(leaseKey);
      }
    } finally { busy = false; announceOperation(); }
  }
  function handle(item) {
    const match = String(item.url || '').match(/\/products\/([^/?#]+)/);
    return String(item.handle || item.productHandle || match && match[1] || '');
  }
  async function productVariants(items) {
    const result = {};
    const handles = [...new Set(items.map(handle).filter(Boolean))];
    await Promise.all(handles.map(async name => {
      if (!/^[a-z0-9_-]+$/i.test(name)) return;
      const response = await request('products/' + encodeURIComponent(name) + '.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const data = await response.json();
      (data.variants || []).forEach(v => { result[Number(v.id)] = {price:Number(v.price), available:Boolean(v.available), productHandle:name}; });
    }));
    return result;
  }
  async function load(cart) {
    if (await pendingState(cart)) throw new Error('A previous gift request needs checking before this gift can be edited.');
    const gift = inspect(cart);
    if (!gift) throw new Error('This gift is no longer in your cart.');
    const prices = await productVariants(gift.fruit);
    const grouped = new Map();
    gift.fruit.forEach(line => {
      const key = signature(line, true);
      let item = grouped.get(key);
      if (!item) {
        const current = prices[variant(line)];
        item = {uid:'cart-' + grouped.size, variantId:variant(line), productTitle:line.product_title || line.title || 'Dried fruit',
          variantTitle:line.variant_title || '', quantity:0, price:current ? current.price : Number(line.original_price ?? line.price ?? 0),
          available:current ? current.available : false, productHandle:handle(line),
          properties:clone(props(line)), sellingPlan:plan(line), sources:[]};
        grouped.set(key,item);
      }
      item.quantity += Number(line.quantity);
      item.sources.push(clone(line));
      if (isBlend(line)) {
        item.blend = true; item.carrierSources = carrierFor(cart,line).map(clone);
        item.price = Number(line.original_line_price ?? line.line_price ?? 0) + item.carrierSources.reduce((n,c) => n + Number(c.original_line_price ?? c.line_price ?? c.quantity),0);
        item.variantTitle = props(line)['Bag size'] || item.variantTitle;
      }
    });
    return {reference:gift.reference, recipient:gift.recipient, message:gift.message, service:gift.service,
      items:[...grouped.values()], snapshot:fingerprint(cart)};
  }
  function contents(items) {
    return items.map(item => item.quantity + ' × ' + item.productTitle +
      (item.variantTitle && item.variantTitle !== 'Default Title' ? ' — ' + item.variantTitle : '')).join('; ');
  }
  function aliases(p, names, value) { names.forEach(name => { if (Object.prototype.hasOwnProperty.call(p,name)) p[name] = value; }); }
  // A Sample Pack is one complete four-pouch product, not four gifting units.
  function isSamplePackUnit(item) {
    return Number(item.variantId || item.variant_id || item.id) === 17918422855 || handle(item) === 'australian-dried-fruit-sample-pack';
  }
  function clearStandardLabel(p) {
    if (p['Gift status'] === 'Not a gift — standard packaging') delete p['Gift status'];
    if (p.Packaging === 'Standard packaging') delete p.Packaging;
    return p;
  }
  function fruitProperties(item, draft) {
    if (draft.service === 'none') {
      if (item.productHandle === 'christmas-dried-fruit-gift-packs' || props(item)['_Christmas Gift ID'] || props(item)['Christmas Gift Reference']) throw new Error('Christmas Gift Packs are complete gifts and cannot be converted to standard products.');
      return window.THGiftSafety.standardProperties(item.properties);
    }
    const p = clearStandardLabel(Object.assign({}, item.properties || {}));
    p._Gift='Yes'; p['_Gift quantity']=String(item.quantity); p['_Gift for']=draft.recipient; p['_Gift reference']=draft.reference; p['Part of gift for']=draft.recipient;
    aliases(p, ['Recipient','_Recipient','Gift for','_For gift'],draft.recipient);
    if (isChristmas(draft.service)) p['Gift presentation']=isSamplePackUnit(item) ? 'Present all four Sample Pack pouches together as ONE Christmas gift — $5 per complete bundle, not per pouch' : 'Individually present this packet for Christmas';
    else delete p['Gift presentation'];
    const grouping=giftGrouping(draft);
    if (grouping) p['Gift preparation']=grouping; else delete p['Gift preparation'];
    p['_Gift preparation']=preparationInstructions(draft); p['_Gift service']=draft.service;
    if(draft.message) p['_Gift message']=draft.message; else delete p['_Gift message'];
    return p;
  }
  function giftGrouping(draft) {
    const count=draft.items.reduce((n,item)=>n+Number(item.quantity),0);
    if (draft.service === 'wrap') return 'Wrap all ' + count + ' selected products TOGETHER as ONE gift for ' + draft.recipient + '. Include the personalised card.';
    if (draft.service === 'christmas-paper') return 'Wrap all ' + count + ' prepared products TOGETHER in festive Christmas paper as ONE gift for ' + draft.recipient + '.';
    return '';
  }
  function preparationInstructions(draft) {
    const description=contents(draft.items), grouping=giftGrouping(draft);
    if (isChristmas(draft.service)) return 'Present each selected product in festive clear packaging with ribbon, Christmas decorations and a Christmas tag. ' + (draft.items.some(isSamplePackUnit) ? 'A complete Sample Pack is ONE product: keep its four pouches together as one bundle. ' : '') + (grouping || 'No additional festive Christmas paper selected.') + ' Gift for ' + draft.recipient + '. Gift contents: ' + description + '.';
    if (draft.service === 'wrap') return grouping + ' Gift contents: ' + description + '.';
    return 'Prepare these products with the personalised card for ' + draft.recipient + '. No gift wrapping selected. Gift contents: ' + description + '.';
  }
  function draftForInstructions(gift) {
    return {reference:gift.reference,recipient:gift.recipient,message:gift.message,service:gift.service,
      items:gift.fruit.map(line=>({variantId:variant(line),quantity:Number(line.quantity),productTitle:line.product_title || line.title || 'Dried fruit',variantTitle:line.variant_title || '',productHandle:handle(line)}))};
  }
  function serviceProperties(old, draft, extra) {
    const p = Object.assign({}, props(old));
    p['_Gift reference']=draft.reference;
    const description = contents(draft.items);
    // Replace known service labels when switching services; retain unrelated custom properties.
    ['_Service','Service','Gift service','Gift option','Card message','Personalised card','Christmas tag message','Preparation instructions'].forEach(key => delete p[key]);
    if (extra) {
      p['_For gift']=draft.recipient; p['_Wrapping for']=description;
      p['Gift service']=extra === 'paper' ? 'Festive paper — wrap the whole gift together' : 'Additional wrapping for ' + draft.recipient;
      p['Preparation instructions']=preparationInstructions(draft);
    } else {
      p.Recipient=draft.recipient; p['_Gift contains']=description;
      p['Gift summary']='ONE PERSONALISED GIFT — FOR ' + draft.recipient.toUpperCase(); p['Gift includes']=description;
      const christmas=isChristmas(draft.service);
      const label=christmas ? (draft.items.every(isSamplePackUnit) ? 'Christmas presentation — $5 per complete Sample Pack bundle, not per pouch' : 'Christmas presentation — $5 per product or complete Sample Pack bundle') + (draft.service === 'christmas-paper' ? ' + $2 whole-gift paper' : '') : draft.service === 'wrap' ? 'Gift Wrapping + Personalised Card' : 'Personalised Card';
      p._Service=label; p['Gift option']=label;
      if (christmas) {
        if (draft.message) p['Christmas tag message']=draft.message;
        p['Preparation instructions']=preparationInstructions(draft);
      } else { p['Card message']=draft.message; p['Preparation instructions']=preparationInstructions(draft); }
      aliases(p,['Gift contains'],description);
    }
    aliases(p,['Recipient','_Gift for','_Recipient','Gift for','Part of gift for','_For gift'],draft.recipient);
    return p;
  }
  function addLine(id, quantity, properties, sellingPlan) {
    const item = {id:Number(id),quantity,properties};
    if (sellingPlan) item.selling_plan=Number(sellingPlan);
    return item;
  }
  function planSave(cart, draft) {
    const standard=draft.service === 'none';
    if (draft.items.length && !standard) validateService(draft);
    const gift = inspect(cart);
    if (!gift || gift.reference !== draft.reference || fingerprint(cart) !== draft.snapshot) throw new Error('Your gift changed in another tab. Reload it before saving.');
    const additions=[], reductions=[], metadata=[], final={};
    const draftIdentities=new Set();
    draft.items.forEach(item=>{
      const p=fruitProperties(item,draft);delete p['_Gift quantity'];
      const identity=signature({id:item.variantId,selling_plan:item.sellingPlan,properties:p});
      if(!standard && draftIdentities.has(identity)) throw new Error('Two selections refer to the same packet. Please combine their quantities before saving.');
      draftIdentities.add(identity);
    });
    function finish(line, quantity, properties) {
      if (quantity) changeAmount(final, signature(addLine(variant(line),quantity,properties,plan(line))),quantity);
    }
    function allocate(sources, desired, targetProperties) {
      // Aggregate identical identities, including any Shopify discount-split rows.
      const grouped=new Map();
      sources.forEach(line => {
        const sig=signature(line);
        if (!grouped.has(sig)) grouped.set(sig,{line,quantity:0});
        grouped.get(sig).quantity+=Number(line.quantity);
      });
      const entries=[...grouped.values()];
      const total=entries.reduce((n,e)=>n+e.quantity,0);
      const extra=Math.max(0,desired-total);
      if (extra && entries.length) additions.push(addLine(variant(entries[0].line),extra,clone(props(entries[0].line)),plan(entries[0].line)));
      let remaining=desired;
      entries.forEach((entry,index)=>{
        const current=entry.quantity+(index===0?extra:0);
        const keep=Math.min(remaining,current); remaining-=keep;
        const sig=signature(entry.line);
        if (keep<current) reductions.push({kind:'quantity',signature:sig,quantity:keep});
        if (keep && stable(props(entry.line))!==stable(targetProperties)) metadata.push({kind:'properties',signature:sig,properties:targetProperties});
        finish(entry.line,keep,targetProperties);
      });
    }
    const savedSources=new Set();
    draft.items.forEach(item => {
      if (!Number.isSafeInteger(item.quantity) || item.quantity<1 || !Number.isSafeInteger(Number(item.variantId)) || ids.includes(Number(item.variantId))) throw new Error('Please check the selected packet quantities.');
      const properties=fruitProperties(item,draft);
      if (item.sources && item.sources.length) {
        item.sources.forEach(line => savedSources.add(signature(line)));
        allocate(item.sources,item.quantity,properties);
      } else {
        additions.push(addLine(item.variantId,item.quantity,properties,item.sellingPlan));
        finish({variant_id:item.variantId,selling_plan:item.sellingPlan},item.quantity,properties);
      }
    });
    draft.items.filter(item => item.blend).forEach(item => {
      if (item.quantity !== 1) throw new Error('Each personalised blend is one bag. Create another blend on the blend page.');
      if (item.sources && item.sources.length) {
        const original = gift.fruit.find(line => isBlend(line) && props(line)._byo_group === item.properties._byo_group);
        if (!original || variant(original) !== Number(item.variantId) || props(original)._BYO_STATE !== item.properties._BYO_STATE || props(original)._byo_price_cents !== item.properties._byo_price_cents)
          throw new Error('Edit the fruit or bag size through the personalised blend page.');
        const sources = carrierFor(cart,original);
        sources.forEach(line => savedSources.add(signature(line)));
        const cp = Object.assign({}, props(sources[0]), {'_Gift reference':draft.reference, '_Gift for':draft.recipient, 'Part of gift for':draft.recipient});
        aliases(cp,['Recipient','_Recipient','Gift for','_For gift'],draft.recipient);
        allocate(sources,Number(sources[0].quantity),standard ? window.THGiftSafety.standardProperties(cp) : clearStandardLabel(cp));
      } else {
        const c = item.carrierLine;
        if (!c || Number(c.id) !== 45956039901355 || Number(c.quantity) !== Number(item.properties._byo_price_cents) || c.properties._byo_group !== item.properties._byo_group)
          throw new Error('The blend price could not be verified.');
        const cp = Object.assign({},c.properties,{'_Gift reference':draft.reference,'_Gift for':draft.recipient,'Part of gift for':draft.recipient});
        const target=standard ? window.THGiftSafety.standardProperties(cp) : clearStandardLabel(cp);
        additions.push(addLine(c.id,c.quantity,target));finish({variant_id:c.id},c.quantity,target);
      }
    });
    gift.lines.filter(line => !isService(line)).forEach(line=>{if(!savedSources.has(signature(line))) reductions.push({kind:'quantity',signature:signature(line),quantity:0});});
    const count=draft.items.reduce((n,i)=>n+i.quantity,0);
    if (!count || standard) {
      gift.lines.filter(isService).forEach(line=>reductions.push({kind:'quantity',signature:signature(line),quantity:0}));
    } else {
      const expectedServices = serviceLines(draft,count);
      const desiredIds = new Set(expectedServices.map(line => line.id));
      gift.lines.filter(line => isService(line) && !desiredIds.has(variant(line))).forEach(line => reductions.push({kind:'quantity',signature:signature(line),quantity:0}));
      expectedServices.forEach(service => {
        const sources=gift.lines.filter(line => variant(line) === service.id);
        const properties=serviceProperties(sources[0] || (service.kind ? {} : gift.main),draft,service.kind);
        if (sources.length) allocate(sources,service.quantity,properties);
        else {
          additions.push(addLine(service.id,service.quantity,properties));
          finish({variant_id:service.id},service.quantity,properties);
        }
      });
    }

    if (standard) cart.items.filter(line=>!isGift(line)).forEach(line=>changeAmount(final,signature(line),Number(line.quantity)));
    return {version:3,reference:draft.reference,standard,index:0,expected:amounts(cart,standard),final,
      ops:[...(additions.length?[{kind:'add',items:additions}]:[]),...reductions,...metadata],observed:true,mode:'edit',reviewPrices:clone(draft.items)};
  }
  function verifyServicePrices(cart) {
    cart.items.filter(isService).forEach(line=>{
      const expected=[WRAP,CHRISTMAS].includes(variant(line))?500:200;
      if (line.original_price != null && Number(line.original_price)!==expected) throw new Error('A gifting service price has changed. Please review the actual cart charges before checkout.');
    });
  }
  async function validatePrices(draft) {
    const prices=await productVariants(draft.items);
    let changed=false;
    draft.items.forEach(item=>{
      const current=prices[item.variantId];
      if (item.blend) {
        if (item.quantity !== 1) throw new Error('Each personalised blend is one bag. Create another blend on the blend page.');
        if (!item.sources?.length && (!current || !current.available || current.price !== 0))
          throw new Error('Please check that this personalised blend size is available and its base variant remains $0.');
        return;
      }
      const original=(item.sources||[]).reduce((n,line)=>n+Number(line.quantity),0);
      if ((!current || !current.available) && item.quantity>original) throw new Error(item.productTitle+' is unavailable. Remove the new packet or choose another available option.');
      if (current && Number(item.price)!==current.price) { item.price=current.price; changed=true; }
    });
    if (changed) { const error=new Error('A product price has changed. Please review the updated total and save again.'); error.code='PRICE_CHANGED'; throw error; }
  }
  function nextMap(current, op, cart, all) {
    const result=clone(current);
    if(op.kind==='add') op.items.forEach(item=>changeAmount(result,signature(item),item.quantity));
    else {
      const qty=current[op.signature]||0;
      const matches=cart.items.filter(item=>(all || isGift(item))&&signature(item)===op.signature);
      const line=op.kind==='quantity'?matches[matches.length-1]:matches[0];
      if(!line) throw new Error('Gift details changed. Please review your cart.');
      if(op.kind==='quantity') changeAmount(result,op.signature,-Math.min(Number(line.quantity),qty-op.quantity));
      else {
        changeAmount(result,op.signature,-Number(line.quantity));
        changeAmount(result,signature(Object.assign({},line,{properties:op.properties})),Number(line.quantity));
      }
    }
    return result;
  }
  async function write(op, cart, all) {
    let body,path;
    if(op.kind==='add') { body={items:op.items};path='cart/add.js'; }
    else {
      const matches=cart.items.filter(item=>(all || isGift(item))&&signature(item)===op.signature);
      if (!matches.length) throw new Error('Gift lines changed. Please review your cart.');
      const line=op.kind==='quantity'?matches[matches.length-1]:matches[0];
      const total=matches.reduce((n,item)=>n+Number(item.quantity),0);
      body={id:line.key,quantity:op.kind==='quantity'?Number(line.quantity)-Math.min(Number(line.quantity),total-op.quantity):line.quantity};
      if(op.kind==='properties') body.properties=op.properties;
      path='cart/change.js';
    }
    const response=await request(path,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    // Every outcome is reconciled by run(), including 422s and lost responses.
    if(!response.ok) {const error=new Error('Shopify could not complete a gift update.');error.isHTTP=true;throw error;}
    // change.js returns the complete updated cart. add.js returns only added lines.
    // If the response cannot be used, run() still reconciles with a fresh cart read.
    if (path === 'cart/change.js') {
      try {
        const cart = await response.json();
        if (cart && Array.isArray(cart.items) && Number.isInteger(cart.item_count) &&
          Number.isFinite(cart.total_price) && cart.items.every(item => item.key &&
            Number.isInteger(item.quantity) && item.quantity > 0 && Number.isSafeInteger(Number(item.variant_id)))) return cart;
      } catch (_) {}
    }
    return null;
  }
  async function run(record) {
    while(record.index<record.ops.length) {
      const cart=await readCart(), current=amounts(cart,record.standard), op=record.ops[record.index];
      if(!equal(current,record.expected)) throw new Error('Your cart changed during this save. Please review it before continuing.');
      if(op.kind==='quantity' && (current[op.signature]||0)===op.quantity || op.kind==='properties' && !current[op.signature]) {
        record.index++;remember(record);continue;
      }
      const after=nextMap(current,op,cart,record.standard);
      record.next=after; record.attempted=true; record.hasWritten=true; record.response='unknown'; remember(record);
      let writeError, updatedCart;
      try { updatedCart=await write(op,cart,record.standard); } catch(error) { writeError=error; }
      record.response=writeError ? (writeError.isHTTP?'http-error':'unknown') : 'ok';remember(record);
      let actual;
      try { actual=updatedCart || await readCart(); }
      catch (_) { throw new Error('We could not confirm the gift update. Please do not submit it again; check the saved changes below.'); }
      const actualMap=amounts(actual,record.standard);
      if(actual.items.some(item=>reference(item)===record.reference)) record.observed=true;
      if(!equal(actualMap,after)) {
        remember(record);
        throw new Error(writeError ? 'Some gift changes could not be confirmed. Review your cart or finish the verified remaining changes below.' : 'Your gift changed while it was being saved. Please review your cart.');
      }
      record.expected=after;
      if(op.kind==='add' || (op.kind==='quantity' ? (after[op.signature]||0)===op.quantity : !after[op.signature])) record.index++;
      delete record.next; record.attempted=false; remember(record);
    }
    const cart=await readCart();
    if(!equal(amounts(cart,record.standard),record.final)) throw new Error('The saved gift does not match the requested changes. Please review your cart.');
    if(Object.keys(record.final).length) { inspect(cart); verifyServicePrices(cart); }
    record.complete=true; remember(record); forget();
    announceCart(cart);
    return cart;
  }
  async function save(draft) {
    return withLock(async()=>{
      const cart=await readCart();
      if(await pendingState(cart)) throw new Error('A previous gift request needs checking before another change can be saved.');
      await validatePrices(draft);
      const record=planSave(cart,draft);
      remember(record);
      try {return await run(record);} catch(error) {if(!record.hasWritten) forget();throw error;}
    });
  }
  async function remove(ref) {
    return withLock(async () => {
      const cart = await readCart();
      const previous = await pendingState(cart);
      if (previous && (previous.legacy || previous.reference !== ref || !previous.observed))
        throw new Error('A previous gift request must be checked before removal. Review the gift in the builder first.');
      const lines = cart.items.filter(item => reference(item) === ref);
      if (!ref || !lines.length) throw new Error('This gift is no longer in your cart. Please reload the cart.');
      const expected = amounts(cart), final = Object.assign({}, expected);
      const signatures = [...new Set(lines.map(item => signature(item)))];
      signatures.forEach(key => delete final[key]);
      const record = {version:3, reference:ref, mode:'remove', index:0, expected, final,
        observed:true, ops:signatures.map(key => ({kind:'quantity',signature:key,quantity:0}))};
      remember(record);
      const result = await run(record);
      if (result.items.some(item => reference(item) === ref)) throw new Error('Some gift lines remain. Please review the cart.');
      sessionStorage.removeItem('th-gift-pending:' + root);
      announceCart(result);
      return result;
    });
  }
  async function checkoutCheck() {
    if (busy) throw new Error('A gift request is already running. Please wait before checkout.');
    const cart = await readCart();
    if (busy) throw new Error('A gift request is already running. Please wait before checkout.');
    if (!cart.items.some(isGift)) {
      // Storage is only required to protect gifts; keep ordinary checkout available.
      try { if (await pendingState(cart)) throw new Error('A previous gift save is unresolved. Please review the cart before checkout.'); }
      catch (error) { if (!/enable browser storage/.test(error.message)) throw error; }
      return cart;
    }
    return withLock(async () => {
      const current = await readCart();
      if (await pendingState(current)) throw new Error('A gift save needs checking before checkout. Please review the gift in the cart.');
      inspect(current); verifyServicePrices(current);
      return current;
    });
  }
  async function create(items, draft) {
    return withLock(async()=>{
      const cart=await readCart();
      if(await pendingState(cart)) throw new Error('A previous gift request needs checking before another gift can be added.');
      const standard=draft?.service === 'none';
      if (standard && cart.items.some(isGift)) { inspect(cart); verifyServicePrices(cart); }
      if(!standard && cart.items.some(isGift)) { const error=new Error('You already have a gift in your cart.'); error.code='EXISTING_GIFT';error.cart=cart;throw error; }
      if(draft) await validatePrices(draft);
      const ref=standard ? 'standard-'+Date.now() : reference(items[0]);
      const final=standard ? amounts(cart,true) : {};items.forEach(item=>changeAmount(final,signature(item),item.quantity));
      const record={version:3,reference:ref,standard,index:0,expected:standard?amounts(cart,true):{},final,ops:[{kind:'add',items}],observed:false,mode:'create',reviewPrices:draft?clone(draft.items):null};
      remember(record);try {return await run(record);} catch(error) {if(!record.hasWritten) forget();throw error;}
    });
  }
  async function createDraft(draft) {
    const d=clone(draft);
    if (d.reference) throw new Error('Save an existing gift through its gift editor.');
    d.recipient=String(d.recipient || '').trim();d.message=String(d.message || '').trim();
    const standard=d.service === 'none';
    if (standard) { d.recipient=''; d.message=''; }
    if (!standard) validateService(d);
    if (!d.items?.length) throw new Error('Choose at least one gift product.');
    if (isChristmas(d.service) && window.THGiftConfig?.christmasEnabled !== true) throw new Error('Christmas gifting is currently unavailable for new gifts. Choose a regular gift option.');
    d.reference='gift-'+Date.now()+'-'+Math.random().toString(36).slice(2,8);
    const items=[], groups=new Set();
    d.items.forEach(item=>{
      if(!Number.isSafeInteger(Number(item.quantity)) || Number(item.quantity)<1 || Number(item.quantity)>20) throw new Error('Check your gift product quantities.');
      const p=fruitProperties(item,d);
      items.push(addLine(Number(item.variantId),Number(item.quantity),p));
      if(item.blend) {
        const c=item.carrierLine, group=p._byo_group;
        if(Number(item.quantity)!==1 || !p._BYO_STATE || !group || groups.has(group) || !c || Number(c.id)!==45956039901355 ||
          !Number.isSafeInteger(Number(c.quantity)) || Number(c.quantity)<1 || Number(c.quantity)!==Number(p._byo_price_cents) || Number(item.price)!==Number(c.quantity) || props(c)._byo_group!==group)
          throw new Error('Your personalised blend and its price need checking together.');
        groups.add(group);
        const cp=Object.assign({},props(c),{'_Gift reference':d.reference,'_Gift for':d.recipient,'Part of gift for':d.recipient});
        items.push(addLine(Number(c.id),Number(c.quantity),standard ? window.THGiftSafety.standardProperties(cp) : clearStandardLabel(cp)));
      }
    });
    const packets=d.items.reduce((n,item)=>n+Number(item.quantity),0);
    if (!standard) serviceLines(d,packets).forEach(service => items.push(addLine(service.id,service.quantity,serviceProperties({},d,service.kind))));
    return create(items,d);
  }
  async function resume() {
    return withLock(async()=>{
      const record=pending();
      if(!record) throw new Error('There is no pending gift save.');
      if(record.mode==='external') throw new Error('Please review the product-page addition in your cart. It cannot safely be submitted again automatically.');
      const cart=await readCart(), actual=amounts(cart,record.standard);
      if(record.reviewPrices) {
        const items=clone(record.reviewPrices);
        items.forEach(item=>{item.sources=cart.items.filter(line=>!isService(line)&&reference(line)===record.reference&&variant(line)===Number(item.variantId)&&plan(line)===Number(item.sellingPlan||0));});
        await validatePrices({items});
      }
      if(record.next && equal(actual,record.next)) {
        const op=record.ops[record.index];
        record.expected=record.next;
        if(op.kind==='add' || (op.kind==='quantity' ? (record.next[op.signature]||0)===op.quantity : !record.next[op.signature])) record.index++;
        delete record.next;record.attempted=false;remember(record);
      } else if(record.attempted && record.response!=='http-error') {
        throw new Error('The previous request outcome is still uncertain or the cart changed afterward. It will not be submitted again. Please review your cart.');
      } else if(!equal(actual,record.expected)) {
        const op=record.ops[record.index];
        if(!record.next || !op || op.kind!=='add') throw new Error('The cart has changed beyond these saved steps. Please review the actual gift; no further changes were made.');
        const keys=new Set([...Object.keys(record.expected),...Object.keys(record.next),...Object.keys(actual)]);
        for(const key of keys) {
          const n=actual[key]||0, before=record.expected[key]||0, after=record.next[key]||0;
          if(n<before || n>after) throw new Error('The cart has changed beyond these saved steps. Please review the actual gift.');
        }
        const missing=op.items.map(item=>Object.assign({},item,{quantity:(record.next[signature(item)]||0)-(actual[signature(item)]||0)})).filter(item=>item.quantity>0);
        // Merge duplicate signatures in the remaining batch.
        const grouped=new Map();missing.forEach(item=>{const s=signature(item);if(!grouped.has(s))grouped.set(s,item);});
        record.ops[record.index]={kind:'add',items:[...grouped.values()]};record.expected=actual;delete record.next;record.attempted=false;remember(record);
      }
      return run(record);
    });
  }
  function beginExternal(ref, cart) {
    if(pending()) throw new Error('A previous gift save needs checking before more gift items can be added.');
    remember({version:3,reference:ref,index:0,expected:amounts(cart),final:{},ops:[],observed:false,mode:'external'});
  }
  function observeExternal(cart) {
    const record=pending();
    if(record && record.mode==='external' && cart.items.some(item=>reference(item)===record.reference)) {record.observed=true;remember(record);}
  }
  function announceOperation() {
    if (typeof window.dispatchEvent === 'function' && typeof CustomEvent === 'function')
      window.dispatchEvent(new CustomEvent('th-gift-operation-state'));
  }
  function announceCart(cart) {
    if (typeof window.dispatchEvent === 'function' && typeof CustomEvent === 'function')
      window.dispatchEvent(new CustomEvent('th-gift-cart-state', {detail:cart}));
  }
  function completeExternal(ref, cart) {
    const record=pending();
    if(record && record.mode==='external' && record.reference===ref) { forget(); if (cart) announceCart(cart); }
  }
  async function normaliseFruitMarkers(cart, ref) {
    const gift=inspect(cart);
    if(!gift || gift.reference!==ref) throw new Error('Your gift details need checking in the cart.');
    const draft=draftForInstructions(gift), groups=new Map();
    function productIdentity(line) {
      const p=Object.assign({},props(line));delete p['_Gift quantity'];delete p['Gift preparation'];delete p['_Gift preparation'];delete p['_Gift message'];delete p['_Gift service'];
      return signature(Object.assign({},line,{properties:p}));
    }
    gift.fruit.forEach(line=>{const key=productIdentity(line);groups.set(key,(groups.get(key)||0)+Number(line.quantity));});
    let expected=amounts(cart), latest=cart;
    for(const original of gift.lines) {
      if(isCarrier(original)) continue;
      const properties=Object.assign({},props(original));
      if(isService(original)) properties['Preparation instructions']=preparationInstructions(draft);
      else {
        if(Object.prototype.hasOwnProperty.call(properties,'_Gift quantity')) properties['_Gift quantity']=String(groups.get(productIdentity(original)));
        const grouping=giftGrouping(draft);
        if(grouping) properties['Gift preparation']=grouping; else delete properties['Gift preparation'];
        properties['_Gift preparation']=preparationInstructions(draft); properties['_Gift service']=draft.service;
        if(draft.message) properties['_Gift message']=draft.message; else delete properties['_Gift message'];
      }
      const sig=signature(original);
      if(stable(properties)===stable(props(original))) continue;
      while(expected[sig]) {
        const fresh=await readCart();
        if(!equal(amounts(fresh),expected)) throw new Error('Your gift changed while its packing instructions were being saved. Please review the cart.');
        const op={kind:'properties',signature:sig,properties}, after=nextMap(expected,op,fresh);
        try {await write(op,fresh);} catch (_) { /* Reconcile even if the response was lost. */ }
        latest=await readCart();
        if(!equal(amounts(latest),after)) throw new Error('Your gift packing instructions need checking in the cart.');
        expected=after;
      }
    }
    return latest;
  }
  async function saveBlend(input) {
    return withLock(async () => {
      const before = await readCart();
      if (await pendingState(before)) throw new Error('A previous gift change needs checking before adding this blend.');
      if (input.snapshot !== fingerprint(before)) throw new Error('Your gift changed. Refresh the gift options before adding your blend.');
      const pair = input.editGroup ? before.items.filter(i => props(i)._byo_group === input.editGroup) : [];
      if (input.editGroup && (pair.length !== 2 || !pair.some(isCarrier) || !pair.some(i => !isCarrier(i))))
        throw new Error('The original blend and its price could not be found together. Review your cart.');
      const old = pair.find(i => !isCarrier(i));
      if (input.editGroup && input.originalSnapshot !== JSON.stringify(pair.map(i => [i.key,i.quantity,props(i)])))
        throw new Error('The original blend changed. Reopen it from your cart before saving.');
      const gift = inspect(before);
      const choice = old && reference(old) ? 'existing' : input.choice;
      if (!['new','existing'].includes(choice) || (choice === 'new' && gift) || (choice === 'existing' && !gift))
        throw new Error('Your gift options have changed. Refresh them and choose again.');
      const recipient = gift ? gift.recipient : String(input.recipient || '').trim();
      const message = gift ? gift.message : String(input.message || '').trim();
      validateService({recipient,message,service:gift ? gift.service : input.service});
      if (!gift && isChristmas(input.service) && window.THGiftConfig?.christmasEnabled !== true) throw new Error('Christmas gifting is currently unavailable for new gifts. Choose a regular gift option.');
      const ref = gift ? gift.reference : 'gift-' + Date.now() + '-' + Math.random().toString(36).slice(2,8);
      const line = input.line, c = input.carrier;
      if (Number(line.quantity) !== 1 || !props(line)._BYO_STATE || !props(line)._byo_group || Number(c.id) !== 45956039901355 ||
        !Number.isSafeInteger(c.quantity) || c.quantity < 1 || c.quantity !== Number(props(line)._byo_price_cents) || props(c)._byo_group !== props(line)._byo_group)
        throw new Error('Your blend and its price could not be verified.');
      const draft = gift ? await load(before) : {reference:ref,recipient,message,service:input.service,items:[],snapshot:fingerprint(before)};
      if (old && reference(old)) draft.items = draft.items.filter(i => i.properties._byo_group !== input.editGroup);
      const item = {uid:props(line)._byo_group,variantId:Number(line.id),productTitle:input.title || 'Personalised blend',variantTitle:props(line)['Bag size'],
        productHandle:input.handle,quantity:1,price:c.quantity,properties:clone(props(line)),sources:[],blend:true,carrierLine:clone(c)};
      draft.items.push(item);
      await validatePrices(draft);
      let record;
      if (gift) record = planSave(before,draft);
      else {
        const fp = fruitProperties(item,draft);
        const cp = Object.assign({},props(c),{'_Gift reference':ref,'_Gift for':recipient,'Part of gift for':recipient});
        const items = [addLine(line.id,1,fp),addLine(c.id,c.quantity,clearStandardLabel(cp)),...serviceLines(draft,1).map(service => addLine(service.id,service.quantity,serviceProperties({},draft,service.kind)))];
        const final={};items.forEach(i=>changeAmount(final,signature(i),i.quantity));
        record={version:3,reference:ref,index:0,expected:amounts(before),final,ops:[{kind:'add',items}],observed:false,mode:'create',reviewPrices:clone(draft.items)};
      }
      remember(record);
      let result;
      try { result = await run(record); } catch(error) { if(!record.hasWritten) forget(); throw error; }
      // A previously ordinary blend is removed only after its new gift version is confirmed.
      if (old && !reference(old)) {
        beginExternal(ref,result);
        const fresh = await readCart();
        const actualPair = fresh.items.filter(i => props(i)._byo_group === input.editGroup);
        if (JSON.stringify(actualPair.map(i => [i.key,i.quantity,props(i)])) !== input.originalSnapshot)
          throw new Error('Your gift blend was added, but the previous ordinary blend changed. Review both in your cart before continuing.');
        try { await request('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:Object.fromEntries(actualPair.map(i=>[i.key,0]))})}); } catch (_) {}
        result = await readCart();
        if (result.items.some(i => props(i)._byo_group === input.editGroup))
          throw new Error('Your gift blend was added, but the previous ordinary blend remains. Remove the old ordinary blend in your cart before continuing.');
        inspect(result); completeExternal(ref,result);
      }
      return result;
    });
  }
  window.THGiftCart={version:7,root,readCart,inspect,fingerprint,load,save,remove,checkoutCheck,create,resume,pending,pendingState,withLock,isBusy:()=>busy,
    isGift,isService,isChristmas,isCarrier,isBlend,carrierFor,saveBlend,createDraft,reference,signature,amounts,planSave,validatePrices,beginExternal,observeExternal,completeExternal,normaliseFruitMarkers,preparationInstructions,giftGrouping,draftForInstructions};
})();


(function () {


  'use strict';


  var CARD_VARIANT_ID = 47692607750315;


  var WRAP_VARIANT_ID = 47692607783083;


  var EXTRA_WRAP_VARIANT_ID = 47701244346539;


  function getBuilder() {


    return document.getElementById('th-gift-builder-v2');


  }


  function getRecipient(root) {


    var input = root.querySelector('#th-recipient');


    if (!input) {


      return '';


    }


    return input.value.trim();


  }


  function getSelectedService(root) {


    var selected = root.querySelector('.th-service.is-selected');


    if (!selected) {


      return '';


    }


    return selected.getAttribute('data-service') || '';


  }


  function getMessage(root) {


    var input = root.querySelector('#th-message');


    if (!input) {


      return '';


    }


    return input.value.trim();


  }


  /*


   * Read the products from the visible gift summary.


   *


   * We capture:


   * - variant ID


   * - quantity


   * - product title


   * - variant title


   *


   * This lets Shopify retain a clear private description


   * of exactly what belongs in the gift.


   */


  function getGiftItems(root) {


    var items = [];


    var rows = root.querySelectorAll(


      '#th-gift-items .th-gift-item'


    );


    var i;


    for (i = 0; i < rows.length; i += 1) {


      var minusButton = rows[i].querySelector(


        '.th-summary-minus'


      );


      if (!minusButton) {


        continue;


      }


      var variantId = Number(


        minusButton.getAttribute('data-id')


      );


      var quantityElement = rows[i].querySelector(


        '.th-summary-qty span'


      );


      var quantity = 1;


      if (quantityElement) {


        quantity = parseInt(


          quantityElement.textContent,


          10


        ) || 1;


      }


      var productNameElement = rows[i].querySelector(


        '.th-gift-item-name'


      );


      var variantElement = rows[i].querySelector(


        '.th-gift-item-variant'


      );


      var productTitle = '';


      if (productNameElement) {


        productTitle =


          productNameElement.textContent.trim();


      }


      var variantTitle = '';


      if (variantElement) {


        variantTitle =


          variantElement.textContent.trim();


      }


      if (variantId) {


        items.push({


          id: variantId,


          quantity: quantity,


          productTitle: productTitle,


          variantTitle: variantTitle


        });


      }


    }


    return items;


  }


  function totalPhysicalItems(items) {


    var total = 0;


    var i;


    for (i = 0; i < items.length; i += 1) {


      total += items[i].quantity;


    }


    return total;


  }


  /*


   * Creates a clear fulfilment description, for example:


   *


   * 2 × Australian Dried Pineapple — 150g;


   * 1 × Dried Fruit Mix — 500g


   */


  function buildGiftContents(items) {


    var descriptions = [];


    var i;


    for (i = 0; i < items.length; i += 1) {


      var item = items[i];


      var description =


        String(item.quantity) +


        ' × ' +


        item.productTitle;


      if (


        item.variantTitle &&


        item.variantTitle !== 'Default Title'


      ) {


        description +=


          ' — ' +


          item.variantTitle;


      }


      descriptions.push(description);


    }


    return descriptions.join('; ');


  }


  function showError(root, message) {


    var errorBox = root.querySelector('#th-cart-error');


    if (!errorBox) {


      errorBox = document.createElement('div');


      errorBox.id = 'th-cart-error';


      errorBox.style.marginTop = '12px';


      errorBox.style.padding = '12px 14px';


      errorBox.style.border = '1px solid #d7aaa4';


      errorBox.style.borderRadius = '7px';


      errorBox.style.background = '#fff3f1';


      errorBox.style.color = '#7a4036';


      var button = root.querySelector(


        '#th-prototype-finish'


      );


      if (button && button.parentNode) {


        button.parentNode.insertBefore(


          errorBox,


          button.nextSibling


        );


      }


    }


    errorBox.textContent = message;


    errorBox.hidden = false;


  }


  function clearError(root) {


    var errorBox = root.querySelector('#th-cart-error');


    if (errorBox) {


      errorBox.hidden = true;


      errorBox.textContent = '';


    }


  }


  function createGiftReference() {


    return (


      'TH-GIFT-' +


      new Date().getTime() +


      '-' +


      Math.floor(Math.random() * 100000)


    );


  }


  function buildCartItems(


    productItems,


    recipient,


    service,


    message


  ) {


    var cartItems = [];


    var giftReference = createGiftReference();


    var physicalItemCount =


      totalPhysicalItems(productItems);


    var giftContents =


      buildGiftContents(productItems);


    var i;


    /*


     * PHYSICAL GIFT PRODUCTS


     *


     * Operational gift properties are private.


     * Shopify still retains them for the order,


     * but they do not clutter customer checkout.


     */


    for (i = 0; i < productItems.length; i += 1) {


      cartItems.push({


        id: productItems[i].id,


        quantity: productItems[i].quantity,


        properties: {


          'Part of gift for': recipient,
          '_Gift': 'Yes',


          '_Gift quantity':


            String(productItems[i].quantity),


          '_Gift for':


            recipient,


          '_Gift reference':


            giftReference


        }


      });


    }


    /*


     * PERSONALISED CARD


     */


    if (service === 'card') {


      cartItems.push({


        id: CARD_VARIANT_ID,


        quantity: 1,


        properties: {


          'Recipient':


            recipient,


          '_Service':


            'Personalised Card',


          'Gift summary': 'ONE PERSONALISED GIFT — FOR ' + recipient.toUpperCase(),
          'Gift includes': giftContents,
          'Gift option': service === 'wrap' ? 'Gift wrapping + personalised card' : 'Personalised card only',
          '_Gift contains':


            giftContents,


          'Card message':


            message,


          '_Gift reference':


            giftReference


        }


      });


    }


    /*


     * GIFT WRAPPING + PERSONALISED CARD


     */


    if (service === 'wrap') {


      cartItems.push({


        id: WRAP_VARIANT_ID,


        quantity: 1,


        properties: {


          'Recipient':


            recipient,


          '_Service':


            'Gift Wrapping + Personalised Card',


          'Gift summary': 'ONE PERSONALISED GIFT — FOR ' + recipient.toUpperCase(),
          'Gift includes': giftContents,
          'Gift option': service === 'wrap' ? 'Gift wrapping + personalised card' : 'Personalised card only',
          '_Gift contains':


            giftContents,


          'Card message':


            message,


          '_Gift reference':


            giftReference


        }


      });


      /*


       * $5 covers the first physical item.


       * Each additional physical item requires


       * one $2 Additional Gift Wrapping unit.


       */


      var additionalWrapCount =


        physicalItemCount - 1;


      if (additionalWrapCount > 0) {


        cartItems.push({


          id: EXTRA_WRAP_VARIANT_ID,


          quantity: additionalWrapCount,


          properties: {


            'Gift service': 'Additional wrapping for ' + recipient,
            '_For gift':


              recipient,


            '_Wrapping for':


              giftContents,


            '_Gift reference':


              giftReference


          }


        });


      }


    }


    return cartItems;


  }


  // One request at a time, including the cart check and the redirect.


  var giftAddInFlight = false;


  function cartHasPersonalisedGift(cart) {


    if (!cart || !Array.isArray(cart.items)) {


      throw new Error('Could not read cart.');


    }


    return cart.items.some(function (item) {


      if (!item || typeof item !== 'object') {


        throw new Error('Could not read cart item.');


      }


      var properties = item.properties || {};


      var variantId = Number(item.variant_id || item.id);


      return String(properties['_Gift reference'] || '').trim() !== '' ||


        properties['_Gift'] === 'Yes' ||


        variantId === CARD_VARIANT_ID ||


        variantId === WRAP_VARIANT_ID ||


        variantId === EXTRA_WRAP_VARIANT_ID || variantId === 48364284313771 || variantId === 48364284674219;


    });


  }


  var cartProtectionState = 'checking';
  var existingGiftReference = '';
  var preflightVersion = 0;
  var builderWasInert = false;
  var builderBusyValue = null;
  var modalReturnFocus = null;
  var savedBodyOverflow = null;


  function readCurrentCart() { return window.THGiftCart.readCart(); }


  function oldReadCurrentCart() {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        reject(new Error('Cart check timed out.'));
        if (controller) controller.abort();
      }, 15000);
      var options = {
        method: 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: {'Accept': 'application/json'}
      };
      if (controller) options.signal = controller.signal;
      fetch('/cart.js', options)
        .then(function (response) {
          if (!response.ok) throw new Error('Could not read cart.');
          return response.json();
        })
        .then(function (cart) { clearTimeout(timer); resolve(cart); })
        .catch(function (error) { clearTimeout(timer); reject(error); });
    });
  }


  function getExistingGiftReference(cart) {
    var mainService = cart.items.find(function (item) {
      var id = Number(item.variant_id || item.id);
      return (id === CARD_VARIANT_ID || id === WRAP_VARIANT_ID || id === 48364284313771) &&
        item.properties && item.properties['_Gift reference'];
    });
    var item = mainService || cart.items.find(function (line) {
      return line.properties && line.properties['_Gift reference'];
    });
    return item ? String(item.properties['_Gift reference']) : '';
  }


  function getGiftModal() {
    var dialog = document.getElementById('th-existing-gift-modal');
    if (dialog) return dialog;
    if (!document.getElementById('th-existing-gift-modal-styles')) {
      var style = document.createElement('style');
      style.id = 'th-existing-gift-modal-styles';
      style.textContent = '#th-existing-gift-modal{box-sizing:border-box;width:calc(100% - 24px);max-width:520px;max-height:calc(100vh - 24px);max-height:calc(100dvh - 24px);margin:auto;padding:24px;border:1px solid #d5e5cf;border-radius:12px;background:#fff;color:#222;font:inherit;line-height:1.5;overflow:auto;overscroll-behavior:contain;}#th-existing-gift-modal::backdrop{background:rgba(0,0,0,.6);}#th-existing-gift-modal *{box-sizing:border-box;}#th-existing-gift-modal h2{margin:0 30px 12px 0;color:#285b32;font-size:24px;line-height:1.2;overflow-wrap:anywhere;}#th-existing-gift-modal p{margin:0 0 12px;overflow-wrap:anywhere;}#th-existing-gift-modal .th-gift-modal-action{display:block;width:100%;min-height:48px;margin-top:10px;padding:12px 14px;border:1px solid #285b32;border-radius:7px;background:#285b32;color:#fff;font:inherit;font-weight:700;line-height:1.4;text-align:center;text-decoration:none;white-space:normal;overflow-wrap:anywhere;cursor:pointer;}#th-existing-gift-modal .th-gift-modal-secondary{background:#fff;color:#285b32;}#th-existing-gift-modal .th-gift-modal-close{position:absolute;top:12px;right:10px;min-width:36px;min-height:36px;border:0;background:transparent;color:#285b32;font:inherit;font-size:24px;cursor:pointer;}#th-existing-gift-modal :focus-visible{outline:3px solid #285b32;outline-offset:3px;}@media(max-width:767px){#th-existing-gift-modal{padding:20px 18px;}#th-existing-gift-modal h2{font-size:22px;}}';
      document.head.appendChild(style);
    }
    dialog = document.createElement('dialog');
    dialog.id = 'th-existing-gift-modal';
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'th-existing-gift-modal-heading');
    dialog.setAttribute('aria-describedby', 'th-existing-gift-modal-description');
    dialog.addEventListener('close', function () {
      if (savedBodyOverflow !== null) {
        document.body.style.overflow = savedBodyOverflow;
        savedBodyOverflow = null;
      }
      if (modalReturnFocus && modalReturnFocus.isConnected) modalReturnFocus.focus();
    });
    // Native dialog handles Escape and makes the rest of the page inert.
    // Closing it never lifts the builder's cart protection.
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = dialog.querySelectorAll('a[href],button:not([disabled])');
      if (!controls.length) return;
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
    document.body.appendChild(dialog);
    return dialog;
  }


  function closeGiftModal() {
    var dialog = document.getElementById('th-existing-gift-modal');
    if (dialog && dialog.open) dialog.close();
  }


  function renderGiftModal(root, failed) {
    var dialog = getGiftModal();
    dialog.textContent = '';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'th-gift-modal-close';
    close.setAttribute('aria-label', 'Close this message');
    close.textContent = '×';
    close.addEventListener('click', closeGiftModal);
    dialog.appendChild(close);
    var heading = document.createElement('h2');
    heading.id = 'th-existing-gift-modal-heading';
    heading.textContent = failed ? 'We could not check your cart' : 'You already have a personalised gift in your cart';
    dialog.appendChild(heading);
    var description = document.createElement('div');
    description.id = 'th-existing-gift-modal-description';
    var paragraphs = failed ? [
      'Please try again before starting your gift. Your cart has not been changed.'
    ] : [
      'Would you like to review your existing gift or complete your order?',
      'Each order can contain one personalised gift. You can edit or add products to that gift.',
      'You can also add standard products and separate ready-made Christmas Gift Packs. Everything in this order goes to the same delivery address.'
    ];
    paragraphs.forEach(function (text) {
      var paragraph = document.createElement('p');
      paragraph.textContent = text; description.appendChild(paragraph);
    });
    dialog.appendChild(description);
    var primary;
    if (failed) {
      primary = document.createElement('button');
      primary.type = 'button'; primary.textContent = 'Try again';
      primary.addEventListener('click', function () {
        closeGiftModal(); checkBuilderCart(root);
      });
    } else {
      primary = document.createElement('a');
      primary.href = '/cart#th-gift-review' +
        (existingGiftReference ? '=' + encodeURIComponent(existingGiftReference) : '');
      primary.textContent = 'Review my existing gift';
    }
    if (!failed) {
      var edit = document.createElement('button'); edit.type='button';
      edit.textContent='Edit my existing gift'; edit.className='th-gift-modal-action';
      edit.addEventListener('click',function() { openCartGift(root); });
      dialog.appendChild(edit);
    }
    primary.className = 'th-gift-modal-action';
    dialog.appendChild(primary);
    [
      ['/cart', 'View cart & complete order'],
      ['/collections/all', 'Continue shopping']
    ].forEach(function (details) {
      var link = document.createElement('a');
      link.href = details[0]; link.textContent = details[1];
      link.className = 'th-gift-modal-action th-gift-modal-secondary';
      dialog.appendChild(link);
    });
    if (!dialog.open) {
      modalReturnFocus = document.activeElement;
      savedBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    }
    primary.focus();
  }


  function clearExistingGiftNotice(root) {
    var oldNotice = root.querySelector('#th-existing-gift-notice');
    if (oldNotice) oldNotice.hidden = true;
    closeGiftModal();
  }


  function showExistingGiftNotice(root, button, cart) {
    cartProtectionState = 'existing';
    if (cart) existingGiftReference = getExistingGiftReference(cart);
    renderGiftModal(root, false);
  }


  function restoreBuilderInteraction(root) {
    root.inert = builderWasInert;
    if (builderBusyValue === null) root.removeAttribute('aria-busy');
    else root.setAttribute('aria-busy', builderBusyValue);
  }


  async function checkBuilderCart(root) {
    var version=++preflightVersion;
    cartProtectionState='checking'; root.inert=true; root.setAttribute('aria-busy','true');
    try {
      var cart=await readCurrentCart();
      if(version!==preflightVersion) return;
      restoreBuilderInteraction(root);
      if(await window.THGiftCart.pendingState(cart)) { cartProtectionState='recovery'; showSaveRecovery(root); return; }
      if(root.thGiftDraft && root.thGiftDraft.get().reference) {
        cartProtectionState='editing';
        if(window.THGiftCart.fingerprint(cart)!==root.thGiftDraft.get().snapshot) showError(root,'Your gift has changed. Reload the existing gift before saving.');
        return;
      }
      var requested=new URLSearchParams(window.location.search).get('th-edit-gift');
      if(requested) {
        var gift=window.THGiftCart.inspect(cart);
        if(!gift || gift.reference!==requested) throw new Error('That gift is no longer available. Please review your cart.');
        await openCartGift(root,cart); return;
      }
      if(cart.items.some(window.THGiftCart.isGift)) {window.THGiftCart.inspect(cart);showExistingGiftNotice(root,null,cart);}
      else {cartProtectionState='clear';existingGiftReference='';closeGiftModal();}
    } catch(error) {
      if(version!==preflightVersion) return;
      restoreBuilderInteraction(root);cartProtectionState='error';renderGiftModal(root,true);
      var text=document.getElementById('th-existing-gift-modal-description');
      if(text) text.textContent=error.message || 'Could not check your cart. Please try again.';
    }
  }


  async function openCartGift(root, suppliedCart) {
    if(giftAddInFlight) return;
    giftAddInFlight=true;
    try {
      var draft=await window.THGiftCart.load(suppliedCart || await readCurrentCart());
      if(!root.thGiftDraft) throw new Error('Please install the matching Stage 3 builder Liquid before editing.');
      root.thGiftDraft.hydrate(draft);
      cartProtectionState='editing';existingGiftReference=draft.reference;closeGiftModal();restoreBuilderInteraction(root);
      var url=new URL(window.location.href);url.searchParams.set('th-edit-gift',draft.reference);
      window.history.replaceState(null,'',url.toString());
      root.querySelector('#th-step-3').scrollIntoView({behavior:'smooth',block:'start'});
    } catch(error) { showError(root,error.message); var d=document.getElementById('th-existing-gift-modal-description');if(d)d.textContent=error.message; }
    finally {giftAddInFlight=false;}
  }


  function showSaveRecovery(root) {
    var dialog=getGiftModal();dialog.textContent='';
    var heading=document.createElement('h2');heading.id='th-existing-gift-modal-heading';heading.textContent='Your gift changes need checking';dialog.appendChild(heading);
    var text=document.createElement('p');text.id='th-existing-gift-modal-description';
    text.textContent='Some changes may already be in your cart. Please review them before checkout. You can finish the verified remaining changes without submitting the whole gift again.';dialog.appendChild(text);
    var resume=document.createElement('button');resume.type='button';resume.className='th-gift-modal-action';resume.textContent='Check & finish saved changes';
    resume.addEventListener('click',async function() {
      if(giftAddInFlight) return;
      if(!window.confirm('Finish the remaining changes from your previous gift save? This may include the removals and gifting charges you already approved.')) return;
      giftAddInFlight=true;resume.disabled=true;
      try {await window.THGiftCart.resume();window.location.assign(window.THGiftCart.root+'cart#th-gift-review='+encodeURIComponent(existingGiftReference || (window.THGiftCart.pending() || {}).reference || ''));}
      catch(error) {text.textContent=error.message+' Your existing cart has not been cleared.';}
      finally {giftAddInFlight=false;resume.disabled=false;}
    });dialog.appendChild(resume);
    [['cart','Review cart before checkout'],['collections/all','Continue shopping']].forEach(function(item) {
      var link=document.createElement('a');link.href=window.THGiftCart.root+item[0];link.textContent=item[1];link.className='th-gift-modal-action th-gift-modal-secondary';dialog.appendChild(link);
    });
    if(!dialog.open) {modalReturnFocus=document.activeElement;savedBodyOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();}
    var record=window.THGiftCart.pending();
    if(!record || record.mode==='external') {resume.hidden=true;text.textContent='A previous product-page gift request needs checking. Please review its products and gifting charges in your cart before checkout. It has not been submitted again.';}
    (resume.hidden ? dialog.querySelector('a') : resume).focus();
  }


  function protectBuilderInteraction(root, event) {
    if (cartProtectionState === 'clear' || cartProtectionState === 'editing') return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.closest('button,input,textarea')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (cartProtectionState === 'recovery') showSaveRecovery(root);
    else if (cartProtectionState === 'existing') renderGiftModal(root, false);
    else if (cartProtectionState === 'error') renderGiftModal(root, true);
  }




  async function submitGift(root, button) {
    if(giftAddInFlight) return;
    if(cartProtectionState==='recovery') {showSaveRecovery(root);return;}
    if(cartProtectionState!=='clear' && cartProtectionState!=='editing') {
      renderGiftModal(root,cartProtectionState==='error');return;
    }
    clearError(root);
    var draft=root.thGiftDraft && root.thGiftDraft.get();
    var editing=Boolean(draft && draft.reference);
    var recipient=getRecipient(root), service=getSelectedService(root), message=getMessage(root), items=getGiftItems(root);
    if(draft && !draft.reviewed) {showError(root,'Please review your latest selections before adding or saving this gift.');return;}
    if(editing) {
      recipient=draft.recipient;service=draft.service;message=draft.message;
      if(!draft.reviewed) {showError(root,'Please review your latest changes before saving.');return;}
    }
    var standard=service==='none';
    if((!standard && (!recipient || (!/^christmas/.test(service) && !message))) || !service || (!editing && !items.length)) {
      showError(root,'Please complete the recipient, products, gift option and personalised message.');return;
    }
    if(editing && !draft.items.length) {
      if(!window.confirm('Remove the complete personalised gift and all its gifting charges? Standard products and ready-made Christmas Gift Packs will stay unchanged.')) return;
    }
    giftAddInFlight=true;button.disabled=true;button.textContent=standard?'Saving standard products…':editing?'Saving gift changes…':'Adding gift to cart…';
    try {
      if(editing) await window.THGiftCart.save(draft);
      else if(draft) await window.THGiftCart.createDraft(draft);
      else await window.THGiftCart.create(buildCartItems(items,recipient,service,message),draft);
      window.THGiftDraft?.clear(root);
      button.textContent=standard?'Standard products saved':editing?'Gift changes saved':'Gift added';
      window.location.assign(window.THGiftCart.root+'cart'+(!standard && editing && draft.items.length?'#th-gift-review='+encodeURIComponent(draft.reference):''));
    } catch(error) {
      if(error.code==='PRICE_CHANGED') root.thGiftDraft.refreshPrices(draft.items);
      if(error.code==='EXISTING_GIFT') showExistingGiftNotice(root,button,error.cart);
      else {showError(root,error.message || 'Could not confirm your gift. Please review your cart.');
        try {if(window.THGiftCart.pending()) {cartProtectionState='recovery';showSaveRecovery(root);}} catch(_) {}
      }
    } finally {giftAddInFlight=false;button.disabled=false;button.textContent=standard?(editing?'Save as standard products':'Add products to cart'):editing?(draft.items.length?'Save changes to gift':'Remove this gift'):"Add "+recipient+"'s gift to cart";}
  }


  function initialise() {


    var root = getBuilder();


    if (!root) {


      return;


    }


    var button = root.querySelector(


      '#th-prototype-finish'


    );


    if (!button) {


      return;


    }


    if (


      button.getAttribute(


        'data-cart-handler'


      ) === 'true'


    ) {


      return;


    }


    button.setAttribute(


      'data-cart-handler',


      'true'


    );


    button.addEventListener(


      'click',


      function (event) {


        event.preventDefault();


        event.stopImmediatePropagation();


        submitGift(


          root,


          button


        );


      },


      true


    );


    builderWasInert = Boolean(root.inert);
    builderBusyValue = root.getAttribute('aria-busy');
    root.addEventListener('click', function (event) {
      protectBuilderInteraction(root, event);
    }, true);
    root.addEventListener('keydown', function (event) {
      protectBuilderInteraction(root, event);
    }, true);
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      giftAddInFlight = false;
      button.disabled = false;
      var recipient = getRecipient(root);
      button.textContent = recipient ? "Add " + recipient + "'s gift to cart" : 'Add gift to cart';
      checkBuilderCart(root);
    });
    root.addEventListener('th-reload-gift',function() {openCartGift(root);});
    root.addEventListener('th-gift-draft-restored',function(){preflightVersion++;cartProtectionState=root.thGiftDraft.get().reference?'editing':'clear';restoreBuilderInteraction(root);closeGiftModal();});
    window.addEventListener('storage',function(event) {if(event.key && event.key.indexOf('th-gift-edit-pending:')===0 && !giftAddInFlight) checkBuilderCart(root);});
    checkBuilderCart(root);


  }


  if (


    document.readyState ===


    'loading'


  ) {


    document.addEventListener(


      'DOMContentLoaded',


      initialise


    );


  } else {


    initialise();


  }


})();


/* Gift cancellation and checked storefront checkout — integrated in the existing asset. */
/* Tropical Harvest gift safety v1. Direct service deletion cancels gifting only.
 * Theme protection: does not run inside hosted Shopify checkout.
 */
(function () {
  'use strict';
  if (window.THGiftSafety) return;
  const root = (window.THGiftSafetyRoot || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const serviceIds = new Set([47692607750315, 47692607783083, 47701244346539, 48364284313771, 48364284674219]);
  const giftKeys = new Set(['Part of gift for','_Gift','Gift','_Gift quantity','_Gift for','Gift for','_Gift reference','Recipient','_Recipient','_For gift','_Wrapping for','_Service','Service','Gift option','Gift service','_Gift contains','Gift contains','Gift includes','Gift summary','Card message','Personalised card','Christmas tag message','Preparation instructions','Gift presentation','Gift preparation','_Gift preparation','_Gift service','_Gift message']);
  const nativeFetch = window.fetch.bind(window);
  const recoveryKey = 'th-gift-standard-pending:' + root;
  let cancelling = false, checking = false, permitCheckout = false, lastCart = null;
  let activeWrites = 0, recoveryPromise = null;
  const props = item => item.properties || {};
  const reference = item => String(props(item)['_Gift reference'] || '');
  const variant = item => Number(item.variant_id || item.id);
  const service = item => serviceIds.has(variant(item));
  const standalone = item => Boolean(props(item)['_Christmas Gift ID'] || props(item)['Christmas Gift Reference']) || /christmas-dried-fruit-gift-packs/.test(item.handle || item.url || '');
  const gifted = item => !standalone(item) && (service(item) || reference(item) || String(props(item)._Gift || props(item).Gift || '').toLowerCase() === 'yes');
  function standardProperties(properties) {
    const result = {};
    for (const [key,value] of Object.entries(properties || {})) if (!giftKeys.has(key)) result[key] = value;
    // Shopify needs a nonempty properties object to replace the last old property.
    if (!Object.keys(result).length) result.Packaging = 'Standard packaging';
    result['Gift status']='Not a gift — standard packaging';
    return result;
  }
  function pending() {
    try { return JSON.parse(sessionStorage.getItem(recoveryKey) || 'null'); }
    catch (_) { throw new Error('We could not check a previous gifting change. Please reload the cart.'); }
  }
  function savePending(value) {
    sessionStorage.setItem(recoveryKey, JSON.stringify(value));
    if (sessionStorage.getItem(recoveryKey) !== JSON.stringify(value)) throw new Error('Please enable browser storage before changing this gift.');
  }
  function paint(cart) {
    if (cart) lastCart = cart;
    const chosen = document.querySelector('input[name="th-gift-choice"]:checked');
    const selectedGift = chosen && chosen.value !== 'none';
    document.documentElement.classList.toggle('th-gift-in-cart', Boolean(selectedGift || lastCart?.items?.some(gifted)));
    document.documentElement.classList.remove('th-gift-checking');
    document.documentElement.classList.toggle('th-gift-cancelling', cancelling);
  }
  async function readCart() {
    const response = await nativeFetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('We could not check your cart. Please try again before checkout.');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('We could not check your cart. Please reload.');
    paint(cart); return cart;
  }
  function notify(cart) {
    paint(cart);
    window.dispatchEvent(new CustomEvent('th-gift-cart-state', {detail:cart}));
  }
  function api() {
    const a = window.THGiftCart;
    if (!a?.withLock || !a?.checkoutCheck) throw new Error('Gift protection is still loading. Please wait and try again.');
    return a;
  }
  async function change(payload) {
    const response = await nativeFetch(root + 'cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
    if (!response.ok) throw new Error('We could not finish removing gifting. Please review your cart before checkout.');
    return readCart();
  }
  function removalReferences(cart, data, action) {
    const refs = new Set();
    function consider(item, quantity) {
      if (!item || !service(item) || quantity === '' || quantity == null || !Number.isFinite(Number(quantity)) || Number(quantity) !== 0) return;
      if (!reference(item)) throw new Error('This gifting charge is missing its gift reference. Please review the gift before changing it.');
      refs.add(reference(item));
    }
    if (action === 'change') {
      if (data.line != null) consider(cart.items[Number(data.line)-1], data.quantity);
      else {
        const matches = cart.items.filter(item => item.key === String(data.id) || String(variant(item)) === String(data.id));
        if (matches.length > 1 && matches.some(service)) throw new Error('Please remove gifting through its gift summary so we can identify the correct charge.');
        consider(matches[0], data.quantity);
      }
    } else if (action === 'update') {
      const updates = data.updates;
      if (Array.isArray(updates)) updates.forEach((q,index) => consider(cart.items[index],q));
      else if (updates && typeof updates === 'object') for (const [id,q] of Object.entries(updates)) {
        const matches = cart.items.filter(item => item.key === id || String(variant(item)) === id);
        if (matches.length > 1 && matches.some(service)) throw new Error('Please remove gifting through its gift summary.');
        consider(matches[0], q);
      }
    }
    return Array.from(refs);
  }
  async function makeStandard(refs, options = {}) {
    if (cancelling || activeWrites || checking) throw new Error('A cart change is still running. Please wait and try again.');
    const a = api(); cancelling = true; paint();
    try {
      return await a.withLock(async function () {
        let cart = await readCart();
        const record = pending();
        if (record && record.cartToken !== cart.token) throw new Error('A saved gifting change belongs to a different cart. Please contact us for help.');
        if (record) refs = record.references;
        else {
          if (await a.pendingState(cart)) throw new Error('A previous gift edit needs checking. Please review it before removing gifting.');
          if (!refs.length || refs.some(ref => !ref)) throw new Error('We could not identify this gift. Please reload your cart.');
          savePending({references:refs,cartToken:cart.token});
        }
        for (const ref of refs) {
          let lines = cart.items.filter(item => reference(item) === ref);
          if (lines.some(standalone)) throw new Error('A standalone Christmas Gift Pack needs checking. Its gift details have been left unchanged.');
          // Remove every service in this group first. Keep all physical products and BYO price carriers.
          for (;;) {
            const line = cart.items.find(item => reference(item) === ref && service(item));
            if (!line) break;
            cart = await change({id:line.key,quantity:0});
            if (cart.items.some(item => item.key === line.key)) throw new Error('The gifting charge was not removed. Please review your cart.');
          }
          for (;;) {
            const line = cart.items.find(item => reference(item) === ref && !service(item));
            if (!line) break;
            const properties = standardProperties(props(line));
            cart = await change({id:line.key,quantity:line.quantity,properties});
            if (cart.items.some(item => item.key === line.key && reference(item) === ref)) throw new Error('Gift details could not be cleared. Please review your cart.');
          }
        }
        // Apply other updates from a native multi-line cart update without re-adding deleted gift services.
        if ((options.otherUpdates && Object.keys(options.otherUpdates).length) || options.updateFields) {
          const response = await nativeFetch(root + 'cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({...options.updateFields,updates:options.otherUpdates || {}})});
          if (!response.ok) throw new Error('Gifting was removed, but another cart quantity needs checking.');
        }
        cart = await readCart();
        if (cart.items.some(item => refs.includes(reference(item)))) throw new Error('Some gift details remain. Please review your cart before checkout.');
        sessionStorage.removeItem(recoveryKey); notify(cart); return cart;
      });
    } finally { cancelling = false; paint(); }
  }
  async function recover() {
    if (!pending()) return;
    if (!recoveryPromise) recoveryPromise = makeStandard([]).finally(() => { recoveryPromise = null; });
    return recoveryPromise;
  }
  function showError(error) {
    let box = document.getElementById('th-gift-safety-message');
    if (!box) {
      box = document.createElement('div'); box.id='th-gift-safety-message'; box.setAttribute('role','alert'); box.tabIndex=-1;
      const target = document.querySelector('#cart-summary, .cart-summary, #cart-drawer .drawer__content, #main-content') || document.body;
      target.prepend(box);
    }
    box.textContent = error.message || 'Please review your gifting choices in the cart before checkout.';
    const link = document.createElement('a'); link.href=root+'cart'; link.textContent=' Review cart'; box.appendChild(link);
    const refs=Array.from(new Set((lastCart?.items || []).filter(gifted).map(reference).filter(Boolean)));
    if (refs.length===1) {
      const button=document.createElement('button');button.type='button';button.className='th-standard-gift-button';
      button.setAttribute('data-th-make-standard',refs[0]);button.textContent='Remove gifting — keep products';box.appendChild(button);
    }
    box.focus();
  }
  async function checkedCheckout(resume) {
    if (checking || cancelling || activeWrites) { showError(new Error('Please wait for your cart change to finish, then try checkout again.')); return; }
    try {
      await recover(); checking=true;
      const cart = await readCart();
      if (window.THGiftCart?.checkoutCheck) await window.THGiftCart.checkoutCheck();
      else if (cart.items.some(gifted)) throw new Error('Gift protection is still loading. Please try again.');
      checking=false;
      permitCheckout=true;
      try { resume(); } finally { permitCheckout=false; }
    } catch (error) { showError(error); }
    finally { checking=false; }
  }
  function checkoutControl(target) {
    const element = target?.closest?.('button,input,a');
    if (!element) return null;
    if (element.matches('[name="checkout"], [data-th-checkout]')) return element;
    if (element.tagName === 'A') {
      try { if (/\/checkout\/?$/.test(new URL(element.href,location.href).pathname)) return element; } catch (_) {}
    }
    return null;
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  window.addEventListener('click', function (event) {
    if (permitCheckout) return;
    const standard = event.target?.closest?.('[data-th-make-standard]');
    if (standard) {
      stop(event);
      makeStandard([standard.getAttribute('data-th-make-standard')]).then(() => location.assign(root+'cart')).catch(showError);
      return;
    }
    const checkout = checkoutControl(event.target);
    if (checkout) { stop(event); checkedCheckout(() => checkout.click()); return; }
    // Protect the plain remove links too, including the short interval before cart grouping finishes.
    const link = event.target?.closest?.('a[href]');
    if (!link) return;
    let url; try { url = new URL(link.href,location.href); } catch (_) { return; }
    if (url.origin !== location.origin || !/\/cart\/change(?:\.js)?\/?$/.test(url.pathname) || url.searchParams.get('quantity') !== '0') return;
    const id = url.searchParams.get('id');
    const item = lastCart?.items?.find(item => item.key === id || String(variant(item)) === id);
    if (!item || !service(item)) return;
    stop(event);
    makeStandard(removalReferences(lastCart,Object.fromEntries(url.searchParams),'change')).then(() => location.assign(root+'cart')).catch(showError);
  },true);
  window.addEventListener('submit', function (event) {
    if (permitCheckout) return;
    const form = event.target;
    if (!form?.action) return;
    const path = new URL(form.action,location.href).pathname;
    if (!/\/cart\/?$/.test(path) && !/\/checkout\/?$/.test(path)) return;
    const button = event.submitter;
    if (button?.name !== 'checkout' && !/\/checkout\/?$/.test(path)) return;
    stop(event);
    checkedCheckout(() => form.requestSubmit(button || undefined));
  },true);
  async function requestData(input, init) {
    let body = init?.body;
    if (body == null && typeof Request !== 'undefined' && input instanceof Request) body = await input.clone().text();
    if (typeof body === 'string') { try { return JSON.parse(body); } catch (_) { body = new URLSearchParams(body); } }
    if (body && typeof body.entries === 'function') {
      const result={},updates={},array=[];
      for (const [key,value] of body.entries()) {
        if (key==='updates[]') array.push(value);
        else if (/^updates\[.+\]$/.test(key)) updates[key.slice(8,-1)] = value;
        else result[key]=value;
      }
      if (array.length) result.updates=array; else if (Object.keys(updates).length) result.updates=updates;
      return result;
    }
    return {};
  }
  async function sectionsResponse(cart,data) {
    let ids = data.sections;
    if (typeof ids==='string') ids=ids.split(',');
    if (Array.isArray(ids) && ids.length) {
      const url = new URL(data.sections_url || root+'cart',location.origin);
      if (url.origin !== location.origin) throw new Error('Please reload your cart to review the change.');
      url.searchParams.set('sections',ids.join(','));
      const response=await nativeFetch(url.href,{credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Gifting was removed. Please reload your cart to see the latest items.');
      cart={...cart,sections:await response.json()};
    }
    return new Response(JSON.stringify(cart),{status:200,headers:{'Content-Type':'application/json'}});
  }
  window.fetch = async function(input,init) {
    let url; try { url=new URL(typeof input==='string' || input instanceof URL ? input : input.url,location.href); } catch (_) { return nativeFetch(input,init); }
    const method=String(init?.method || input?.method || 'GET').toUpperCase();
    const match=url.pathname.match(/\/cart\/(change|update)(?:\.js)?\/?$/);
    if (url.origin!==location.origin || !match || method!=='POST') return nativeFetch(input,init);
    // The shared gift builder holds its own lock while changing valid gift services.
    if (cancelling || checking) throw new Error('Please wait for the gifting change to finish.');
    if (window.THGiftCart?.isBusy?.()) return nativeFetch(input,init);
    const before=await readCart(), data=await requestData(input,init);
    if (cancelling || checking) throw new Error('Please wait for the gifting change to finish.');
    const refs=removalReferences(before,data,match[1]);
    if (refs.length) {
      const otherUpdates={};
      if (match[1]==='update' && data.updates) {
        const pairs=Array.isArray(data.updates) ? data.updates.map((q,i)=>[before.items[i]?.key,q]) : Object.entries(data.updates);
        for (const [key,q] of pairs) {
          const item=before.items.find(item=>item.key===key || String(variant(item))===key);
          if (item && !refs.includes(reference(item))) otherUpdates[key]=q;
          else if (item && !service(item) && Number(q)!==Number(item.quantity)) throw new Error('Please remove gifting first, then change the product quantity.');
        }
      }
      const cart=await makeStandard(refs,{otherUpdates,updateFields:match[1]==='update' ? Object.fromEntries(['note','attributes'].filter(key=>Object.prototype.hasOwnProperty.call(data,key)).map(key=>[key,data[key]])) : null});
      return sectionsResponse(cart,data);
    }
    activeWrites++;
    try { const response=await nativeFetch(input,init); if (response.ok) { try { await readCart(); } catch (_) {} } return response; }
    finally { activeWrites--; }
  };
  window.THGiftSafety = {standardProperties,removalReferences,makeStandard,checkedCheckout,readCart};
  if (!document.getElementById('th-gift-safety-styles')) {
    const style=document.createElement('style');style.id='th-gift-safety-styles';
    style.textContent=".th-gift-checking .shopify-payment-button,.th-gift-checking shopify-accelerated-checkout-cart,.th-gift-checking #dynamic-checkout-cart,.th-gift-checking .additional-checkout-buttons,.th-gift-in-cart .shopify-payment-button,.th-gift-in-cart shopify-accelerated-checkout-cart,.th-gift-in-cart #dynamic-checkout-cart,.th-gift-in-cart .additional-checkout-buttons{display:none!important}.th-standard-gift-button{display:inline-block;margin:10px 12px 4px 0;padding:8px 12px;border:1px solid currentColor;border-radius:5px;background:transparent;color:inherit;cursor:pointer;font:inherit;font-size:13px}.th-gift-cancelling [data-th-make-standard]{pointer-events:none;opacity:.6}#th-gift-safety-message{margin:16px;padding:14px;border:2px solid #a45b00;background:#fff8e8;color:#38240a}";document.head.appendChild(style);
  }
  document.documentElement.classList.add('th-gift-checking');
  window.addEventListener('th-gift-cart-state', event => { if (event.detail?.items) paint(event.detail); });
  document.addEventListener('change', event => { if (event.target?.name==='th-gift-choice') paint(); });
  async function initialise() {
    try { await readCart(); if (pending()) await recover(); }
    catch (error) { if (pending()) showError(error); }
  }
  function addStandardButtons() {
    for (const remove of document.querySelectorAll('.th-remove-gift[data-gift-reference]')) {
      const ref=remove.getAttribute('data-gift-reference');
      const parent=remove.parentElement;
      if (!ref || parent.querySelector('[data-th-make-standard]')) continue;
      const button=document.createElement('button'); button.type='button';
      button.setAttribute('data-th-make-standard',ref);
      button.className='th-standard-gift-button'; button.textContent='Remove gifting — keep products';
      parent.insertBefore(button,remove);
    }

  }
  function startGiftSafety() {
    initialise(); addStandardButtons();
    new MutationObserver(addStandardButtons).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',startGiftSafety,{once:true});
  else startGiftSafety();
  window.addEventListener('pageshow',event=>{if(event.persisted) initialise();});
})();
